// keepers.js — Kingdom of Night keeper data
// Each keeper has a bio, portrait image, and a list of episode IDs.
// Images live in public/keepers/<id>.png

const keepers = [
  {
    id: "night-mother",
    name: "The Night Mother",
    bio: "The Night Mother keeps her cottage at the heart of the Kingdom, where she tends her garden, settles the little ones, and sits quietly in the dark long after all else is still. She is the Kingdom's oldest welcome — unhurried, unjudging, and always there.",
    imageUrl: "/keepers/night-mother.png",
    episodeIds: [1, 8],
  },
  {
    id: "keeper-of-lanterns",
    name: "The Keeper of Lanterns",
    bio: "The Keeper of Lanterns walks the full breadth of the Kingdom each night — from the crossroads to the foreshore — tending the paths and lowering each lantern in turn as the evening deepens. With a dog at their heel and a quiet word for anyone they meet, they close the day gently: road by road, light by light.",
    imageUrl: "/keepers/keeper-of-lanterns.png",
    episodeIds: [2, 10],
  },
  {
    id: "tide-listener",
    name: "The Tide Listener",
    bio: "The Tide Listener keeps their place on the moonlit foreshore, where the river meets the sea and the waves have been arriving since before anyone can remember. They listen to what the ocean carries in and watch what it takes back out — patient, unhurried, and entirely at home with everything the night brings.",
    imageUrl: "/keepers/tide-listener.png",
    episodeIds: [3, 11],
  },
  {
    id: "fire-keeper",
    name: "The Fire Keeper",
    bio: "The Fire Keeper tends the grove at the heart of the Kingdom — splitting wood, feeding the fire, and making room for whoever arrives. He has wide shoulders and a broad welcome, and a particular gift for knowing when someone needs their pack lifted quietly from their back and set aside.",
    imageUrl: "/keepers/fire-keeper.png",
    episodeIds: [4, 12],
  },
  {
    id: "dream-keeper",
    name: "The Dream Keeper",
    bio: "The Dream Keeper works through the night in their lantern-lit workshop, patient and precise, finding the form that each piece was always becoming. They tend a fire borrowed from the Fire Keeper's hearth, and the river that runs beneath their bench gives back what was ready to return.",
    imageUrl: "/keepers/dream-keeper.png",
    episodeIds: [5],
  },
  {
    id: "garden-keeper",
    name: "The Garden Keeper",
    bio: "The Garden Keeper moves through their moonlit beds with a lantern and an unhurried curiosity — pausing for beetles, tending what leans, marvelling at what the dark reveals that daylight does not. The garden is always becoming something, and so, they believe, is everything.",
    imageUrl: "/keepers/garden-keeper.png",
    episodeIds: [6, 9],
  },
  {
    id: "sky-keeper",
    name: "The Sky Keeper",
    bio: "The Sky Keeper keeps the high plateau above the Kingdom, where the sky is unobstructed and the stars turn slowly overhead. They know every constellation — not as facts but as old acquaintances — and have a particular patience for the long view that comes from sitting very still for a very long time.",
    imageUrl: "/keepers/sky-keeper.png",
    episodeIds: [7],
  },
];

export default keepers;
